if(typeof eval("try{require('zlib')}catch(e){}") === 'undefined') { var e = new Error("Cannot find module 'eval(\"try{require('zlib')}catch(e){}\")'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = eval("try{require('zlib')}catch(e){}");